import { viewSelectStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListViewSelect";
import Grid from "@steiner/XDL/Icons/Grid";
import List from "@steiner/XDL/Icons/List";
import Table from "@steiner/XDL/Icons/Table";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 8px;
    `,
};

viewSelectStyles.listViewIcon = {
    src: List,
    size: 20,
    css: css`
        height: 21px;

        &:hover svg {
            color: ${color("primary")};
        }
    `,
};

viewSelectStyles.gridViewIcon = {
    src: Grid,
    size: 20,
    css: css`
        height: 21px;

        &:hover svg {
            color: ${color("primary")};
        }
    `,
};
viewSelectStyles.tableViewIcon = {
    src: Table,
    size: 18,
    css: css`
        height: 21px;

        &:hover svg {
            color: ${color("primary")};
        }
    `,
};

viewSelectStyles.listViewClickable = {
    css: css`
        margin-right: 4px;
    `,
};
viewSelectStyles.gridViewClickable = {};

viewSelectStyles.tableViewClickable = {
    css: css`
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

viewSelectStyles.label = {
    size: 14,
    color: "text",
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        white-space: nowrap;
    `,
};
